import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
    ArmService,
    AuthenticationService,
    EspaceClientService,
    DossierMedicalService,
} from '@kv-common-components/kx-services';
import { DocumentListHelperService } from '@shared/services/document-list-helper.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-recap',
    templateUrl: './recap.component.html',
    styleUrls: ['./recap.component.scss'],
})
export class RecapComponent implements OnInit, OnDestroy {
    neededDocuments: any[] = [];
    passedDataFromPreviousPage: any;
    currentEspaceClientValue: any;
    isLoading = false;
    idDossierMedical: string;
    sentDocuments: any[];
    documentState: { transmis: boolean; idApiTypeExamen: any };
    documentToConsent: any;

    espaceClientSubscription: Subscription;

    constructor(
        private dossierMedicalService: DossierMedicalService,
        private authService: AuthenticationService,
        private espaceCltService: EspaceClientService,
        private armService: ArmService,
        private documentListHelper: DocumentListHelperService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.isLoading = true;
        this.espaceClientSubscription =
            this.espaceCltService.currentEspaceClient.subscribe((espaceClt) => {
                this.currentEspaceClientValue = espaceClt;
                const idDossier = String(
                    this.authService.currentUserValue.idDossier
                );
                const idAia = String(espaceClt.personne.idAia);
                this.dossierMedicalService
                    .getIdDossierMedical(idAia, idDossier)
                    .subscribe(
                        (data) => {
                            this.idDossierMedical = data.idDossierMedical;
                            this.getDocToShowFromHistory(this.idDossierMedical);
                        },
                        (error) => {
                            // no dossierMedical was found
                            if (error.status === 404) {
                                this.getDocToShowFromHistory();
                            }
                        }
                    );
            });
        window.scrollTo(0, 0);
    }

    ngOnDestroy() {
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
    }

    getDocToShowFromHistory(idDossierMedical?: string) {
        // we have the needed document from the document-list page
        if (
            history.state &&
            history.state.data &&
            history.state.data.documentList
        ) {
            this.passedDataFromPreviousPage = history.state.data;
            const missingDocuments = history.state.data.documentList.filter(
                (doc) => !doc.transmis && doc.idApi
            );
            this.neededDocuments = this.documentListHelper.sortListByAttribute(
                missingDocuments,
                'correctLibelle'
            );
            this.isLoading = false;
        } else {
            this.getDocumentsToShow(idDossierMedical);
        }
    }

    getDocumentsToShow(idDossierMedical?: string): void {
        // If we have a medical folder we get the expected medical docs to show from the medial folder
        if (idDossierMedical) {
            this.armService
                .getDossierMedical(idDossierMedical)
                .subscribe((dossier) => {
                    const docsFromEspaceClt =
                        this.documentListHelper.getDocsFromEspaceClt(
                            Number(this.authService.currentUserValue.idDossier),
                            this.currentEspaceClientValue
                        );
                    this.armService
                        .getTypesExamens()
                        .subscribe((typesExamens) => {
                            const listeExamens = this.documentListHelper.merge(
                                { list: typesExamens, mergeAttribute: 'idApi' },
                                {
                                    list: dossier.listeExamen,
                                    mergeAttribute: 'idApiTypeExamen',
                                }
                            );

                            const mergedList = this.documentListHelper
                                .merge(
                                    {
                                        list: docsFromEspaceClt,
                                        mergeAttribute: 'typologie',
                                    },
                                    {
                                        list: listeExamens,
                                        mergeAttribute: 'typeEmprunteur',
                                    }
                                )
                                .filter((doc) => doc.transmis === false);

                            this.neededDocuments =
                                this.documentListHelper.sortListByAttribute(
                                    mergedList,
                                    'correctLibelle'
                                );
                            this.isLoading = false;
                        });
                });
        } else {
            // we get the expected medical docs from espace client that are not present in the documentary space
            this.documentListHelper
                .getMedicalDocumentsByStatus(
                    this.currentEspaceClientValue,
                    this.authService.currentUserValue,
                    'needed'
                )
                .subscribe((response) => {
                    this.neededDocuments = response;
                    this.isLoading = false;
                });
        }
    }

    navigateToPage(url: string): void {
        localStorage.setItem(
            'previousPageUrl',
            '/souscription/document-medicale/recap'
        );
        this.router.navigateByUrl(url, {
            state: {
                data: this.passedDataFromPreviousPage,
            },
        });
    }

    navigateToAppointmentPage(url: string): void {
        url = this.idDossierMedical ? url + 'type' : url + 'consent';
        this.router.navigateByUrl(url);
    }
}
